import { TagInputSettings } from './types';
import { Theme } from '../../../themeBase';

export const tagInputSettings: TagInputSettings = {
  componentVariants: {
    status: {
      prop: 'status',
      variants: {
        default: {
          borderColor: 'gray.light',
        },
        error: {
          borderColor: 'danger.main',
        },
      },
    },
    size: {
      prop: 'size',
      variants: {
        regular: {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: 3,
          paddingRight: 4,
          paddingLeft: 4,
          paddingBottom: 3,
          paddingTop: 3,
          gap: 3,
          boxShadow: (props: Theme) => props.boxShadows.input,
        },
      },
    },
    inputSize: {
      prop: 'inputSize',
      variants: {
        regular: {
          fontSize: 1,
          padding: 2,
          paddingLeft: 3,
          fontFamily: 'secondary',
          lineHeight: 1,
          width: '100%',
          '&::placeholder': {
            color: 'gray.main',
          },
        },
      },
    },
  },
};
